(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var handleResourceCarouselState = function () {
      var cartSummary = document.querySelector('.cart-page__summary');
      var carousels = document.querySelectorAll('.resource-list__carousel');

      if (!carousels.length) return;

      carousels.forEach(function (carousel) {
        if (cartSummary) {
          carousel.classList.add('cart-not-empty');
        } else {
          carousel.classList.remove('cart-not-empty');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleResourceCarouselState);
    } else {
      handleResourceCarouselState();
    }

    document.addEventListener('cart:update', handleResourceCarouselState);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
